import { VehicleDto, SbdDto } from '@services/api/api.service';
import * as L from 'leaflet';

export class VehicleCoords {
  vehicle?: VehicleDto;

  constructor(vehicle: VehicleDto, latLng: L.LatLng) {
    this.vehicle = vehicle;
    this.latLng = latLng;
  }

  latLng?: L.LatLng;

}

export class MarkerCoords {
  original?: any;

  constructor(original: any, latLng: L.LatLng) {
    this.original = original;
    this.latLng = latLng;
  }
  latLng?: L.LatLng;

}

export class VehicleSbdCoords {
  vehicle?: SbdDto;

  constructor(vehicle: SbdDto, latLng: L.LatLng) {
    this.vehicle = vehicle;
    this.latLng = latLng;
  }
  latLng?: L.LatLng;

}



